import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import promise from 'redux-promise-middleware'

// The DevTools extension lets anyone who installs it dispatch arbitrary actions into this
// store. With Friends & Family entitlement held in redux and no server-side check behind it,
// that is a one-click discount, so the extension is wired up outside production only.
const middleware = applyMiddleware(thunk, promise);
const enhancer = process.env.NODE_ENV === 'production' ? middleware : composeWithDevTools(middleware);

const store = createStore(rootReducer, enhancer);

export default store;
